<template>
  <div id="equities">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员权益</h1>
      </div>

      <div class="header-button">
        <el-button v-if="jurisdiction.search" icon="el-icon-search" plain @click="searchBtn"
          >查询</el-button
        >
        <el-button
        v-if="jurisdiction.create"
          icon="el-icon-circle-plus-outline"
          plain
          @click="createVisible = true"
          >新增</el-button
        >
        <el-button v-if="jurisdiction.edit" icon="el-icon-edit-outline" plain @click="modifyBtn"
          >修改</el-button
        >
        <el-button v-if="jurisdiction.look" icon="el-icon-circle-plus-outline" plain @click="handleEdit"
          >查看</el-button
        >
      </div>
    </div>
    <!-- 新增弹窗 -->
    <div class="create">
      <el-dialog
        width="25%"
        title="会员权益管理——新增"
        :visible.sync="createVisible"
        :closeOnClickModal="false"
      >
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="80px"
          :model="createLabelAlign"
          :rules="rulesF"
          ref="rulesForm"
        >
          <el-form-item label="会员等级" prop="levelName">
            <el-select style="width: 100%" v-model="createLabelAlign.levelName">
              <el-option
                v-for="item in searchOptions"
                :key="item.levelID"
                :value="item.levelID"
                :label="item.levelName_cn"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权益名称" prop="equityLevel">
            <el-input v-model="createLabelAlign.equityLevel"></el-input>
          </el-form-item>
          <el-form-item label="权益描述" prop="equityItem">
            <el-input
              type="textarea"
              :rows="3"
              v-model="createLabelAlign.equityItem"
            ></el-input>
          </el-form-item>
          <el-form-item label="页面排序" prop="sortIndex">
            <el-input v-model="createLabelAlign.sortIndex"></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-checkbox-group v-model="createLabelAlign.state">
              <el-checkbox
                :checked="createLabelAlign.state == 1 ? true : false"
                :true-label="1"
                :false-label="0"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="insertList">确 定</el-button>
          <el-button @click="createVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改弹窗 -->
    <div class="amend">
      <el-dialog
        width="25%"
        title="会员权益管理——修改"
        :visible.sync="amendVisible"
        :closeOnClickModal="false"
      >
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="80px"
          :model="modifyLabelAlign"
          :rules="rulesF"
          ref="rulesForm"
        >
          <el-form-item label="会员等级" prop="levelName">
            <el-select style="width: 100%" v-model="modifyLabelAlign.levelID">
              <el-option
                v-for="item in searchOptions"
                :key="item.levelID"
                :value="item.levelID"
                :label="item.levelName_cn"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权益名称" prop="equityLevel">
            <el-input v-model="modifyLabelAlign.equityLevel"></el-input>
          </el-form-item>
          <el-form-item label="权益描述" prop="equityItem">
            <el-input
              type="textarea"
              :rows="3"
              v-model="modifyLabelAlign.equityItem"
            ></el-input>
          </el-form-item>
          <el-form-item label="页面排序" prop="sortIndex">
            <el-input v-model="modifyLabelAlign.sortIndex"></el-input>
          </el-form-item>
          <el-form-item label="是否启用" prop="state">
            <el-checkbox-group v-model="modifyLabelAlign.state">
              <el-checkbox
                :checked="modifyLabelAlign.state == 1 ? true : false"
                :true-label="1"
                :false-label="0"
              >
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modeSave">确 定</el-button>
          <el-button @click="modeClose">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查看弹窗 -->
    <div class="examine">
      <el-dialog
        width="25%"
        title="会员权益管理——查看"
        :visible.sync="examineVisible"
        :closeOnClickModal="false"
      >
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="80px"
          :model="lookLabelAlign"
          disabled
        >
          <el-form-item label="会员等级">
            <el-input
              style="width: 100%"
              v-model="lookLabelAlign.levelName"
            ></el-input>
          </el-form-item>
          <el-form-item label="权益名称">
            <el-input v-model="lookLabelAlign.equityLevel"></el-input>
          </el-form-item>
          <el-form-item label="权益描述">
            <el-input
              type="textarea"
              :rows="3"
              v-model="lookLabelAlign.equityItem"
            ></el-input>
          </el-form-item>
          <el-form-item label="页面排序">
            <el-input v-model="lookLabelAlign.sortIndex"></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-checkbox-group v-model="lookLabelAlign.state">
              <el-checkbox
                :checked="lookLabelAlign.state == 1 ? true : false"
                :true-label="1"
                :false-label="0"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <!-- <div slot="footer" class="dialog-footer">
          <el-button @click="examineVisible = false">取 消</el-button>
        </div> -->
      </el-dialog>
    </div>
    <el-card shadow="never">
      <el-form
        style="margin-top: 20px"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        size="mini"
      >
        <el-form-item label="会员等级">
          <el-select v-model="formInline.levelID" placeholder="请选择">
            <el-option
              v-for="item in searchOptionssy"
              :key="item.levelID"
              :value="item.levelID"
              :label="item.levelName_cn"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
    <div>
      <Table
        :tableData="tableData"
        :configTable="configTable"
        :config="config"
        ref="refsTable"
        :tableHeight="tableHeight"
        @selectChange="selectChange"
        @load="load"
      ></Table>
    </div>
  </div>
</template>
<script>
import Table from "@/components/table";
import configTable from "./equities";
import { getcpyNo, dateTime } from "@/utils/auth";
import {
  queryLSelectApi,
  tequityPageApi,
  upDateByIDApi,
  tequityInsertApi,
  tequityqueryApi,
} from "@/api/user";
export default {
  name: "centre",
  components: {
    Table,
  },
  data() {
    return {
      radioValueList: [], // 首页选中的数据
      configTable,
      tableHeight: "610px",
      examineVisible: false, //查看
      amendVisible: false, //修改
      createVisible: false,
      labelPosition: "right",
      formInline: {
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        levelID: "",
      },
      searchOptions: [],
      searchOptionssy: [],
      formLabelAlign: {},
      createLabelAlign: {
        levelName: "",
        equityLevel: "",
        equityItem: "",
        sortIndex: "",
        state: "",
      },
      //修改
      modifyLabelAlign: {
        levelName:"",
        equityLevel:"",
        equityItem:"",
        sortIndex:"",
        state:"",
        ID:"",
        levelID:""
      },
      // 查看
      lookLabelAlign: {},
      // 查看弹窗列表请求参数
      lookLabelAligncs: {
        ID: "",
      },
      tableData: [],
      config: {
        count: 1,
        pages: 50, // 页码数
        pagesTotal: 0,
        loading: true,
        total: 0,
        pageNo: 1,
      },
      //新增表单的验证规则
      rulesF: {
        levelName: [
          { required: true, message: "请选择会员等级", trigger: "change" },
        ],
        equityLevel: [
          { required: true, message: "请填写权益名称", trigger: "blur" },
        ],
        equityItem: [
          { required: true, message: "请填写权益描述", trigger: "blur" },
        ],
        sortIndex: [{ required: true, message: "请填写排序", trigger: "blur" }],
        state: [{ required: true, message: "请选择", trigger: "change" }],
      },
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        look: false,
        delete: false,
      },
    };
  },
  created() {
    this.selectMembers();
    this.membersList();
    let Equities = JSON.parse(localStorage.getItem("Equities"));
    console.log(Equities)
    for (let i = 0; i < Equities.length; i++) {
      if (Equities[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Equities[i].menuName == "新增") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Equities[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }
      if (Equities[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
      if (Equities[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
    }
  },
  methods: {
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    async selectMembers() {
      const { data: res } = await queryLSelectApi({ cpyNO: getcpyNo() });
      this.searchOptionssy.push({
        levelID: "",
        levelName_cn: "全部",
      });
      this.searchOptionssy.push(...res);
      this.searchOptions = res;
    },

    // 列表
    async membersList(type = false) {
      let queryTable = {
        cpyNO: getcpyNo(),
        levelID: this.formInline.levelID,
        pageNo: this.formInline.pageNo,
        pageSize: this.formInline.pageSize,
      };
      await tequityPageApi(queryTable).then((res) => {
        if (res.message == "success") {
          const data = res.data.list.map((item) => {
            item.state = item.state === 0 ? "禁用" : "启用";
            item.createTime =
              item.createTime == null ? "" : dateTime(item.createTime);
            item.updateTime =
              item.updateTime == null ? "" : dateTime(item.updateTime);
            return item;
          });
          this.formInline.pages = res.pages;
          if (type) {
            this.tableData = [];
          }
          this.config.pagesTotal = res.data.total;
          this.tableData = this.tableData.concat(data);
          this.formInline.pages = res.pages;
          this.config.loading = false;
          this.config.total = res.data.total;
          this.config.pageNo = this.formInline.pageNo;
        }
      });
    },
    load() {
      this.config.loading = true;
      setTimeout(() => {
        this.tableData = [];
        this.formInline.pages += 1;
        this.formInline.pageNo += 1;
        this.$refs.refsTable.radio = "";
        this.membersList(true);
      }, 500);
    },
    searchBtn() {
      this.config.loading = true;
      setTimeout(() => {
        this.formInline.pages = 1;
        this.formInline.pageNo = 1;
        this.tableData = [];
        this.membersList(true);
      }, 500);
    },
    // 选中的数据
    selectChange(row) {
      this.radioValueList = row;
      console.log(row);
    },
    // 查看
    handleEdit() {
      if (this.radioValueList == undefined || this.radioValueList == "")
        return this.$message.info("请选择数据,进行查看!");
      this.lookqq();
      this.tequityquery();
      this.examineVisible = true;
    },
    // 查看接口请求
    tequityquery() {
      tequityqueryApi(this.lookLabelAligncs).then((res) =>{
        this.lookLabelAlign = res.data;
        if (res.success !== true) {
            this.$message.error("查看用户管理列表失败");
            return;
          }else{
            this.$message.success("查看用户管理列表成功");
          }
      })
    },
    // 查看获取id
    lookqq() {
      this.lookLabelAligncs.ID = this.radioValueList.id;
    },
    // 修改弹框
    modifyBtn() {
      if (this.radioValueList == undefined || this.radioValueList == "")
        return this.$message.info("请选择数据!");
      this.lookqq();
      tequityqueryApi(this.lookLabelAligncs).then((res) =>{
        // this.modifyLabelAlign = res.data;
        this.modifyLabelAlign.ID = res.data.id
        this.modifyLabelAlign.levelName = res.data.levelName
        this.modifyLabelAlign.levelID = res.data.levelID
        this.modifyLabelAlign.equityLevel = res.data.equityLevel
        this.modifyLabelAlign.equityItem = res.data.equityItem
        this.modifyLabelAlign.sortIndex = res.data.sortIndex
        this.modifyLabelAlign.state = res.data.state
      })
      this.amendVisible = true;
    },
    modeSave() {
      upDateByIDApi({
        ID: this.modifyLabelAlign.ID,
        cpyNO: getcpyNo(),
        equityItem: this.modifyLabelAlign.equityItem,
        equityLevel: this.modifyLabelAlign.equityLevel,
        levelID: this.modifyLabelAlign.levelID,
        sortIndex: this.modifyLabelAlign.sortIndex,
        state: Number(this.modifyLabelAlign.state),
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("修改成功!");
          this.amendVisible = false;
          this.tableData = [];
          this.membersList();
        } else {
          return this.$message.error("修改失败!");
        }
      });
    },
    // 修改取消
    modeClose() {
      this.tableData = [];
      this.membersList();
      this.amendVisible = false;
    },
    // 创建
    insertList() {
      this.$refs.rulesForm.validate(async (valid) => {
        if (valid) {
          // console.log(valid);
          await tequityInsertApi({
            cpyNO: getcpyNo(),
            equityItem: this.createLabelAlign.equityItem,
            levelID: this.createLabelAlign.levelName,
            equityLevel: this.createLabelAlign.equityLevel,
            sortIndex: this.createLabelAlign.sortIndex,
            state: this.createLabelAlign.state,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("新增成功!");
              this.createVisible = false;
              this.config.count = 1;
              this.tableData = [];
              this.membersList();
            } else {
              return this.$message.error("创建失败!");
            }
          });
        } else {
          console.log("死鬼你要填写完整数据哦!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#equities {
  // height: 1350px;
  height: 100%;
}
.header {
  .header-text {
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
  .examine {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
}
</style>
